import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export interface Il {
  il_kodu: string;
  il_adi: string;
}

export interface Ilce {
  id: number;
  il_kodu: string;
  ilce_adi: string;
}

export function useIller() {
  const [iller, setIller] = useState<Il[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('iller')
      .select('il_kodu, il_adi')
      .order('il_adi')
      .then(({ data }) => {
        if (data) setIller(data);
        setLoading(false);
      });
  }, []);

  return { iller, loading };
}

export function useIlceler(ilKodu: string) {
  const [ilceler, setIlceler] = useState<Ilce[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!ilKodu) {
      setIlceler([]);
      return;
    }
    setLoading(true);
    supabase
      .from('ilceler')
      .select('id, il_kodu, ilce_adi')
      .eq('il_kodu', ilKodu)
      .order('ilce_adi')
      .then(({ data }) => {
        if (data) setIlceler(data);
        setLoading(false);
      });
  }, [ilKodu]);

  return { ilceler, loading };
}
